import { FormItemProps } from "@/shared/form/form";

export function onlyOneDocument(): FormItemProps {
  return {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getValueProps: (value: any) => ({ value: value ? [value] : undefined }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    normalize: (value: any) => {
      const result = Array.isArray(value) && value.length > 0 ? value[0] : null;

      return result;
    },
  };
}
